export const requestChangeIbanErrors = {
  invalidIbanError: 'invalidIbanError',
  invalidIbanMessage: 'Iban is invalid',
};
